__turbopack_context__.v({
  "nav-container": "_8IZVOq_nav-container",
  "nav-menu": "_8IZVOq_nav-menu",
  "tab": "_8IZVOq_tab",
  "tabs": "_8IZVOq_tabs",
});
